import axios from "axios"

export const userSend = async(user_id,type)=>{
    let formdata = {
        user_id,type
    }
    let url = localStorage.getItem("api_url") + "usersend"
    const result = await axios.post(url,formdata)
    return result
}